<template>
  <div class="searchIndex wrapper">
    <div class="ques-detail">
      <ul>
        <li v-for="(que, queIndex) in questions" :key="que.Data.SID" :class="{ pushed: que.PushID && que.PushID > 0 }">
          <div v-if="pushFlagShow && que.Data.TaskQuestionID > 0" class="pushFlag">
            预
          </div>
          <fieldset :id="typeName + queIndex" class="quesborder" s="math">
            <!-- <div class="pt3"><em>【题型】</em>{{que.Data.CateName}}
						</div> -->
            <div class="pt1">
              [{{ que.Data.CateName }}]
              <a href="#">{{ que.Data.Label }}</a>
              <span v-html="que.Data.Content"></span>
            </div>
            <div class="pt2" v-if="que.Options && que.Options.length > 0">
              <ul style="width: 100%" class="ques quesborder que-options">
                <li
                  class="selectoption"
                  v-for="(option, index) in que.Options"
                  :key="'que' + queIndex + 'option' + index"
                >
                  <label class="QA-options">
                    <input
                      :name="'QA-' + queIndex"
                      :id="'QA-' + queIndex + '_' + index"
                      :value="index"
                      :type="que.Data.QuestionType == 1 ? 'radio' : 'checkbox'"
                      :class="que.Data.QuestionType == 1 ? 'radio' : 'checkbox'"
                      :checked="que.Answers && que.Answers.indexOf(index + '') != -1"
                      disabled="disabled"
                    />
                    {{ optNums[index] + " . " }}
                    <span v-html="option"></span>
                  </label>
                </li>
              </ul>
            </div>
            <div v-show="que.OpenDetail">
              <div v-if="que.QuestionPoints && que.QuestionPoints.length > 0" class="pt3">
                <!--B3-->
                <em>【考点】</em>
                <a
                  v-for="point in que.QuestionPoints"
                  :key="'que' + queIndex + 'point' + point.Key"
                  :href="'#' + point.Key"
                >
                  {{ point.Value }}、
                </a>
              </div>
              <div v-if="que.QuestionTopics && que.QuestionTopics.length > 0" class="pt4">
                <!--B4-->
                <em>【专题】</em>
                <a
                  v-for="topic in que.QuestionTopics"
                  :key="'que' + queIndex + 'topic' + topic.Key"
                  :href="'#' + topic.Key"
                >
                  {{ topic.Value }}、
                </a>
              </div>
              <div v-if="que.Answers && que.Answers.length > 0" class="pt11">
                <!--B4-->
                <em>【答案】</em>
                <div v-html="que.Data.DisplayAnswer"></div>
              </div>
              <div v-if="que.Data.Analyse" class="pt5">
                <!--B5-->
                <em>【分析】</em>
                <div v-html="que.Data.Analyse"></div>
              </div>
              <div v-if="que.Data.Method" class="pt6">
                <!--B6-->
                <em>【解答】</em>
                <div v-html="que.Data.Method"></div>
              </div>
              <div v-if="que.Data.Discuss" class="pt7">
                <!--B7-->
                <em>【点评】</em>
                <div v-html="que.Data.Discuss"></div>
              </div>
            </div>
          </fieldset>
          <div class="fieldtip">
            <div class="fieldtip-left">
              <span>更新：{{ que.Data.QuestionDate ? que.Data.QuestionDate.substr(0, 10) : "" }}</span>
              <span>组卷：{{ que.Data.PaperCount }}</span>
              <span>难度：{{ que.Data.Degree }}</span>
            </div>
            <div class="fieldtip-right">
              <a v-if="editable" href="javascript:void(0)" @click="editQuestion(queIndex)">
                <i class="el-icon-edit-outline"></i>
                变式
              </a>
              <a href="javascript:void(0)" @click="openOrCloseDetail(queIndex)">
                <i :class="que.OpenDetail ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                {{ que.OpenDetail ? "收起解析" : "查看解析" }}
              </a>
              <a v-if="needFill" href="javascript:void(0)" @click="fillQueDetail(queIndex)">
                <i class="el-icon-document-checked"></i>
                填充解析
              </a>
              <a v-if="similarEnable" href="javascript:void(0)" @click="similarQuestions(queIndex)">
                <i class="el-icon-search"></i>
                相似题
              </a>
              <template v-if="pushEnable">
                <a
                  v-if="que.PushID && que.PushID > 0"
                  href="javascript:void(0)"
                  class="btn remove"
                  @click="removePush(queIndex)"
                >
                  移出推题
                </a>
                <a v-else href="javascript:void(0)" class="btn" @click="addPush(queIndex)">加入推题</a>
              </template>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
/* import "../../assets/css/questionStyle.css";
import "../../assets/js/library.js"; */
export default {
  name: "QuestionBankList",
  props: {
    //一个页面如果使用多个此组件，使用typeName区分，防止相同题目ID出现
    typeName: "",
    // 题库试题列表
    questions: [],
    // 是否显示“填充解析”操作，默认false不显示
    needFill: {
      type: Boolean,
      default: false,
    },
    // 是否显示“编辑”操作，默认false不显示
    editable: {
      type: Boolean,
      default: false,
    },
    // 是否显示“相似题”，默认true显示，相似题用的地方比较多所以默认true
    similarEnable: {
      type: Boolean,
      default: true,
    },
    // 是否显示“推题”操作，默认false不显示
    pushEnable: {
      type: Boolean,
      default: false,
    },
    //是否显示预设题的标志
    pushFlagShow: {
      type: Boolean,
      default: false,
    },
    
  },
  data() {
    return {
      // 选项字母数组
      optNums: ["A", "B", "C", "D", "E", "F", "G"],
    };
  },

  mounted() {
    if (this.questions && this.questions.length > 0) {
      let that = this;
      setTimeout(function() {
        that.computeOptionCols(that.questions);
      }, 300);
    }
  },
  updated() {
    let that = this;
    setTimeout(function() {
      that.computeOptionCols(that.questions);
    }, 300);
  },
  methods: {
    /* 打开或关闭答案解析详情 */

    /* openOrCloseDetail(queIndex) {
      this.$emit("openOrCloseDetail", queIndex, this.questions);
    }, */
    /* 填充解析详情，触发父组件填充解析 */
    /* fillQueDetail(queIndex) {
      this.$emit("fillQueDetail", queIndex, this.questions);
    }, */
    /* 展开或关闭试题解析详情 */
    openOrCloseDetail(queIndex) {
      let que = this.questions[queIndex];
      if (!que.OpenDetail) {
        //未展开解析详情，展开
        if (que.Data.DetailSaved == 1) {
          //已经有解析详情，直接展开显示
          this.$set(que, "OpenDetail", true);
        } else {
          //还未加载解析详情，先调接口获取详情后再展开显示
          this.getQueDetail(queIndex);
        }
      } else {
        // 已展开，收起
        this.$set(que, "OpenDetail", false);
      }
    },
    /* 获取试题解析详情接口，更新数据 */
    getQueDetail(queIndex, callback) {
      let old = this.questions[queIndex];
      let that = this;
      this.axios
        .get(window.hosturl + "/rest/questionBank/GetQuestionAnalysis?SID=" + this.questions[queIndex].Data.SID)
        .then((res) => {
          if (res.data.result == 200) {
            let que = res.data.data;
            que.OpenDetail = true;
            que.PushID = old.PushID;
            this.questions.splice(queIndex, 1, que);
            // console.log(this.searchData);
            if (callback) {
              callback(que);
            }
          }
        });
    },

    /* 填充解析 */
    fillQueDetail(queIndex) {
      // console.log("当前编辑的题目", this.question);
      let que = this.questions[queIndex];
      if (que.Data.DetailSaved == 1) {
        //已经有解析详情，填充表单
        this.fillQueForm(que);
      } else {
        //还未加载解析详情，先调接口获取详情后再填充表单
        this.getQueDetail(queIndex, this.fillQueForm);
      }
    },
    fillQueForm(que) {
      this.$emit("fillQueForm", que);
    },
    /* 查找相似题，触发父组件查找相似题打开相似题对话框 */
    similarQuestions(queIndex) {
      this.$emit("similarQuestions", queIndex, this.questions);
    },
    /* 移出推题，触发父组件移出推题 */
    removePush(queIndex) {
      this.$emit("removePush", queIndex, this.questions);
    },
    /* 加入推题，触发父组件加入推题 */
    addPush(queIndex) {
      this.$emit("addPush", queIndex, this.questions);
    },
    /* 变式编辑，触发父组件打开编辑对话框修改 */
    editQuestion(queIndex) {
      this.$emit("editQuestion", queIndex, this.questions);
    },
    /* 计算选择题选项li的width更新合适的展示比例 */
    computeOptionCols(questions) {
      if (questions && questions.length > 0) {
        for (let i = 0; i < questions.length; i++) {
          let colNum = 1;
          let que = questions[i];
          if (que.Options && que.Options.length > 0) {
            let queDom = document.getElementById(this.typeName + i);
            let ulW = queDom.querySelector(".que-options").offsetWidth;
            let optionLis = queDom.querySelectorAll(".selectoption");
            let count = optionLis.length;
            let maxW = 0;

            for (let optionLi of optionLis) {
              // 先清除宽度设置，后面计算完之后重新赋值
              optionLi.style.width = "";
              if (optionLi.offsetWidth > maxW) {
                maxW = optionLi.offsetWidth;
              }
            }
            switch (count) {
              case 1:
                colNum = 1;
                break;
              case 2:
                if (maxW > ulW * 0.48) {
                  colNum = 1;
                } else {
                  colNum = 2;
                }
                break;
              case 3:
                if (maxW > ulW * 0.48) {
                  colNum = 1;
                } else if (maxW > ulW * 0.32) {
                  colNum = 2;
                } else {
                  colNum = 3;
                }
                break;
              case 4:
                if (maxW > ulW * 0.48) {
                  colNum = 1;
                } else if (maxW > ulW * 0.23) {
                  colNum = 2;
                } else {
                  colNum = 4;
                }
                break;
              case 5:
                if (maxW > ulW * 0.48) {
                  colNum = 1;
                } else if (maxW > ulW * 0.32) {
                  colNum = 2;
                } else if (maxW > ulW * 0.19) {
                  colNum = 3;
                } else {
                  colNum = 5;
                }
                break;
              case 6:
                if (maxW > ulW * 0.48) {
                  colNum = 1;
                } else if (maxW > ulW * 0.32) {
                  colNum = 2;
                } else if (maxW > ulW * 0.16) {
                  colNum = 3;
                } else {
                  colNum = 6;
                }
                break;
            }
            let w = (1 / colNum - 0.02) * 100 + "%";
            for (let optionLi of optionLis) {
              optionLi.style.width = w;
            }
            que.colNum = colNum;
          }
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/detail/QuestionBankList.vue